import {useState} from "react"
import {hasUrlFlag, URL_FLAG__LIGHTVERSION} from "../Helper/UrlFlag"
const SESSION_KEY = 'progress'

const STEP__ROOM = 'room'
const STEP__SHAPE = 'shape'
const STEP__WALL = 'wall'
const STEP__FLOOR = 'floor'
const STEP__CEILING = 'ceiling'
const STEP__NOISE = 'noise'
const STEP__CONDITIONS = 'conditions'
const STEP__SOLUTION = 'solution'


const PROGRESS = [
    STEP__ROOM,
    STEP__SHAPE,
    STEP__WALL,
    STEP__FLOOR,
    STEP__CEILING,
    STEP__NOISE,
    STEP__CONDITIONS,
    STEP__SOLUTION,
]

const initFromSession = (initialState) => {
    return sessionStorage.getItem(SESSION_KEY)
        ? sessionStorage.getItem(SESSION_KEY)
        : initialState
}

export const useProgress = (roomSetup) => {
    const [progress, setProgress] = useState(() => initFromSession(STEP__ROOM))

    const setProgressPlugin = newStep => {
        if (PROGRESS.indexOf(newStep) === PROGRESS.indexOf(progress)) {
            return
        }

        if (PROGRESS.indexOf(newStep) < PROGRESS.indexOf(progress)) {
            setProgress(newStep)
            sessionStorage.setItem(SESSION_KEY, newStep)
            return
        }

        if (roomSetup.validate(progress)) {
            setProgress(newStep)
            sessionStorage.setItem(SESSION_KEY, newStep)
        }
    }

    const getProgress = () => progress
    const isRoom = () => progress === STEP__ROOM
    const gotoRoom = () => setProgressPlugin(STEP__ROOM)
    const isShape = () => progress === STEP__SHAPE
    const gotoShape = () => setProgressPlugin(STEP__SHAPE)
    const isWall = () => progress === STEP__WALL
    const gotoWall = () => setProgressPlugin(STEP__WALL)
    const isFloor = () => progress === STEP__FLOOR
    const gotoFloor = () => setProgressPlugin(STEP__FLOOR)
    const isCeiling = () => progress === STEP__CEILING
    const gotoCeiling = () => setProgressPlugin(STEP__CEILING)
    const isNoise = () => progress === STEP__NOISE
    const gotoNoise = () => setProgressPlugin(STEP__NOISE)
    const isConditions = () => progress === STEP__CONDITIONS
    const gotoConditions = () => setProgressPlugin(STEP__CONDITIONS)
    const isSolution = () => progress === STEP__SOLUTION
    const gotoSolution = () => setProgressPlugin(STEP__SOLUTION)

    const next = () => {
        var lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)
        if (isRoom()) gotoShape()
        else if (isShape() && !lightversion) gotoWall()
        else if (isShape() && lightversion) gotoSolution()
        else if (lightversion) gotoSolution()
        else if (isWall()) gotoFloor()
        else if (isFloor()) gotoCeiling()
        else if (isCeiling()) gotoNoise()
        else if (isNoise()) gotoConditions()
        else if (isConditions()) gotoSolution()
    }

    const prev = () => {
        var lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)
        if (isSolution() && !lightversion) gotoConditions()
        else if (isSolution() && lightversion) gotoShape()
        else if (isShape() && lightversion) gotoRoom()
        else if (lightversion) gotoShape()
        else if (isConditions()) gotoNoise()
        else if (isNoise()) gotoCeiling()
        else if (isCeiling()) gotoFloor()
        else if (isFloor()) gotoWall()
        else if (isWall()) gotoShape()
        else if (isShape()) gotoRoom()
    }

    return {
        getProgress,
        next, prev,
        isRoom, gotoRoom,
        isShape, gotoShape,
        isWall, gotoWall,
        isFloor, gotoFloor,
        isCeiling, gotoCeiling,
        isNoise, gotoNoise,
        isConditions, gotoConditions,
        isSolution, gotoSolution
    }
}
